import { UserName } from "../../../Users/shared/UserName.js";
import { EditButton } from "../../../../components/Buttons/index.js";
import { FilesListDisplay } from "../../../Files/shared/FilesListDisplay.js";
import { ImageSmall } from "../../../../components/ImageSmall/index.js";
import { LocationNames } from "../LocationNames.js";
import { RefCardsList } from "../../../shared/RefsByTypeTitles/components/RefCardsList.js";
import { LocationGroupTags } from "../LocationGroupTags.js";
import dayjs from "dayjs";
import { useMemo } from "react";
import { Icon, Tooltip } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { humanizeMinutes } from "@therms/web-js";
import classnames from "classnames";
import { MdKeyboardDoubleArrowDown } from "react-icons/md";
//#region src/modules/Locations/shared/PassDown/LocationPassDownCard.tsx
function LocationPassDownCard({ onClick, onEdit, passDown, status, truncateBody }) {
	const { activeDate, body, createdByUser, expireDate, fileUrls, locationGroupIds, locationIds, primaryImageUrl, refsByType, title } = passDown;
	const StatusMessage = useMemo(() => {
		let message;
		if (status === "active") message = `Expires in ${humanizeMinutes(dayjs().diff(dayjs(expireDate), "minute"))}`;
		if (status === "future") message = `Activates in ${humanizeMinutes(dayjs().diff(dayjs(activeDate), "minute"))}`;
		if (status === "expired") message = `Expired ${humanizeMinutes(dayjs(expireDate).diff(dayjs(), "minute"))} ago`;
		return /* @__PURE__ */ jsx("span", {
			className: status !== "active" ? "text-color font-medium" : "text-color-subtle",
			children: message
		});
	}, [
		activeDate,
		expireDate,
		status
	]);
	const handleClick = onClick && (() => onClick(passDown));
	return /* @__PURE__ */ jsx("div", {
		className: classnames({ "hover:bg-surface-strong focus:bg-surface-strong active:bg-surface-subtle group cursor-pointer transition-colors": !!onClick }, "bg-surface flex flex-col rounded sm:flex-row"),
		onClick: handleClick,
		children: /* @__PURE__ */ jsxs("div", {
			className: "p-base flex grow flex-col rounded sm:flex-row",
			children: [primaryImageUrl ? /* @__PURE__ */ jsx("div", {
				className: classnames({ "opacity-50": status !== "active" }, "mb-base sm:mr-base shrink-0 sm:mb-0 sm:w-[128px]"),
				children: /* @__PURE__ */ jsx(ImageSmall, {
					src: primaryImageUrl,
					fluid: true,
					fit: "cover",
					rounded: true,
					height: 128
				})
			}) : /* @__PURE__ */ jsx("div", {
				className: classnames({ "opacity-50": status !== "active" }, `mb-base bg-surface-subtle sm:mr-base hidden h-[128px] items-center justify-center rounded sm:mb-0 sm:flex sm:w-[128px]`),
				children: /* @__PURE__ */ jsx(Icon, {
					Icon: MdKeyboardDoubleArrowDown,
					size: "xs",
					color: "neutral",
					className: "h-[100px] w-[100px]"
				})
			}), /* @__PURE__ */ jsxs("div", {
				className: classnames({ "text-color-subtle": status !== "active" }, "grow"),
				children: [
					/* @__PURE__ */ jsxs("div", {
						className: "gap-x-xs flex flex-wrap-reverse items-center",
						children: [
							!!createdByUser?.id && /* @__PURE__ */ jsx(UserName, { user: createdByUser }),
							" ",
							StatusMessage,
							onEdit && /* @__PURE__ */ jsx("div", {
								className: "pb-xs flex grow justify-end",
								children: /* @__PURE__ */ jsx(EditButton, { onClick: onEdit })
							})
						]
					}),
					/* @__PURE__ */ jsxs("div", {
						className: "flex w-full justify-between",
						children: [/* @__PURE__ */ jsx("div", {
							className: classnames({ "group-hover:text-color-strong group-focus:text-color-strong group-active:text-color": !!onClick }, "text-lg font-medium capitalize"),
							children: title
						}), /* @__PURE__ */ jsxs("div", {
							className: "flex-col justify-end",
							children: [/* @__PURE__ */ jsx("div", {
								className: "flex justify-end",
								children: /* @__PURE__ */ jsx(LocationGroupTags, {
									locationGroupIds,
									max: 3
								})
							}), locationIds.length > 1 && /* @__PURE__ */ jsx("div", {
								className: "flex justify-end",
								children: /* @__PURE__ */ jsx(Tooltip, {
									tooltip: locationIds.length > 1 && /* @__PURE__ */ jsx(LocationNames, { locationIds }),
									underline: locationIds.length > 1,
									children: /* @__PURE__ */ jsx(LocationNames, {
										locationIds,
										listAll: false
									})
								})
							})]
						})]
					}),
					/* @__PURE__ */ jsx("div", { className: "mt-xs border-border border-t" }),
					/* @__PURE__ */ jsx("div", {
						className: classnames({ "line-clamp-4": truncateBody }, "mt-sm grow whitespace-pre-wrap"),
						children: body
					}),
					(!!refsByType && !!Object.keys(refsByType).length || Array.isArray(fileUrls) && !!fileUrls.length) && /* @__PURE__ */ jsx("div", { className: "mt-lg border-border border-t" }),
					!!refsByType && !!Object.keys(refsByType).length && /* @__PURE__ */ jsxs("div", {
						className: "mt-xs",
						children: [/* @__PURE__ */ jsx("div", {
							className: "mb-xxs font-medium",
							children: "References"
						}), /* @__PURE__ */ jsx(RefCardsList, { refsByType })]
					}),
					Array.isArray(fileUrls) && !!fileUrls.length && /* @__PURE__ */ jsx("div", {
						className: "mt-xs",
						children: /* @__PURE__ */ jsx(FilesListDisplay, { fileUrls })
					})
				]
			})]
		})
	});
}
//#endregion
export { LocationPassDownCard };

//# sourceMappingURL=LocationPassDownCard.js.map